import * as React from "react";

function IconPorto(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 155 44"
            {...props}
        >
            <path
                d="M47.627 13.783c8.628 0 15.516 6.303 15.516 15.078C63.143 37.633 56.255 44 47.627 44c-8.635 0-15.523-6.367-15.523-15.14 0-8.774 6.888-15.077 15.523-15.077zm77.75 0c8.634 0 15.522 6.303 15.522 15.078 0 8.772-6.888 15.139-15.522 15.139-8.631 0-15.52-6.367-15.52-15.14 0-8.774 6.889-15.077 15.52-15.077zm23.356 17.795c3.48 0 6.267 2.78 6.267 6.245 0 3.399-2.787 6.177-6.267 6.177-3.416 0-6.207-2.778-6.207-6.177 0-3.465 2.79-6.245 6.207-6.245zM101.986 4.266v10.256h5.776v8.1h-5.776V33.06c0 1.673 1.428 1.919 2.548 1.919 1.858 0 3.228-.19 3.228-.19v8.465s-4.655.374-7.08.374c-4.66 0-8.63-1.297-8.63-7.23v-13.76H87.77v-8.116h4.282V4.266h9.934zm-21.91 10.152c.743 0 4.749.104 4.749.104v8.175h-3.6c-4.285 0-5.4 3.697-5.4 7.338v13.22h-9.939V14.522h9.561v4.574c.598-3.27 2.707-4.678 4.63-4.678zM15.706 0c10.868 0 16.398 6.677 16.398 14.832 0 8.158-5.53 15.142-16.398 15.142h-5.093v13.28H0V0h15.706zm31.92 22.744c-3.291 0-5.59 2.532-5.59 6.117 0 3.527 2.299 6.182 5.59 6.182 3.222 0 5.585-2.655 5.585-6.182 0-3.585-2.363-6.117-5.584-6.117zm77.75 0c-3.285 0-5.586 2.532-5.586 6.117 0 3.527 2.3 6.182 5.587 6.182 3.232 0 5.592-2.655 5.592-6.182 0-3.585-2.36-6.117-5.592-6.117zM13.6 9.21h-2.986v11.551H13.6c4.345 0 7.573-1.48 7.573-5.929 0-4.387-3.228-5.622-7.573-5.622z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default IconPorto;
